module.exports = __webpack_public_path__ + "static/media/08-img.34e01240.jpg";